export default __webpack_public_path__ + "static/media/ultimath-cover.f93d4f8e.jpg";